var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"icon":"","loading":_vm.loading,"disabled":_vm.disabled},on:{"click":_vm.click}},[_c('v-icon',[_vm._v("mdi-cached")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }